import React from 'react'
import styled from 'styled-components'
import { Mspaint, Notepad2, Computer, Network2, RecycleFull, Explore, Folder, Wangimg130, MediaCd } from '@react95/icons'
import { startWebamp } from '../utils/startWebamp';
import IconTarget from './IconTarget';

const StyledShorcut = styled(IconTarget)`
    &:focus-visible { outline: 1px dotted white; outline-offset: 2px; }
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80px;
    margin-left: 20px;
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    .icon-wrapper {
        margin-bottom: 4px;
        ${({ isSelected }) => isSelected && `
            filter: contrast(0.5) brightness(1.2) sepia(1) hue-rotate(180deg) saturate(5);
        `}
    }

    .shortcut-label {
        padding: 1px 2px;
        ${({ isSelected }) => isSelected ? `
            background-color: #020242;
            color: white;
            outline: 1px dotted #fff;
        ` : `
            background-color: transparent;
            color: #000;
        `}
    }
`;

const StyledIcon = styled.img`
    width: 32px;
    height: 32px;
    image-rendering: pixelated;
`;

function Shortcuts({ openExplorer, openPaint, openNotepad, openRecycleBin, openInternet, openDoom, openChexQuest, openHamsterDance, openPhoto, openDefrag, openAmbience, activeSelection, setActiveSelection }) {
    const handleIconClick = (id, action, e, activate) => {
        e.stopPropagation();
        setActiveSelection(id);
        if (activate) action();
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', maxHeight: 'calc(100% - 30px)', width: 'fit-content' }}>
            <StyledShorcut
                isSelected={activeSelection === 'computer'}
                onClick={(e, activate) => handleIconClick('computer', openDefrag, e, activate)}
            >
                <div className="icon-wrapper">
                    <Computer variant="32x32_4" />
                </div>
                <div className="shortcut-label">My Computer</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'network'}
                onClick={(e, activate) => handleIconClick('network', openHamsterDance, e, activate)}
            >
                <div className="icon-wrapper">
                    <Network2 variant="32x32_4" />
                </div>
                <div className="shortcut-label">Network Neighborhood</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'internet'}
                onClick={(e, activate) => handleIconClick('internet', openInternet, e, activate)}
            >
                <div className="icon-wrapper">
                    <Explore variant="32x32_4" />
                </div>
                <div className="shortcut-label">The Internet</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'ambience'}
                onClick={(e) => {
                    e.stopPropagation();
                    setActiveSelection('ambience');
                    openAmbience();
                }}
            >
                <div className="icon-wrapper">
                    <MediaCd variant="32x32_4" />
                </div>
                <div className="shortcut-label">Ambience</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'doom'}
                onClick={(e, activate) => handleIconClick('doom', openDoom, e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/doomicon.png`}
                        alt="DOOM.exe"
                    />
                </div>
                <div className="shortcut-label">DOOM</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'chex-quest'}
                onClick={(e, activate) => handleIconClick('chex-quest', openChexQuest, e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/chex.ico`}
                        alt="Chex Quest.exe"
                    />
                </div>
                <div className="shortcut-label">Chex Quest</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'recycle'}
                onClick={(e, activate) => handleIconClick('recycle', openRecycleBin, e, activate)}
            >
                <div className="icon-wrapper">
                    <RecycleFull variant="32x32_4" />
                </div>
                <div className="shortcut-label">Recycle Bin</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'explorer'}
                onClick={(e, activate) => handleIconClick('explorer', openExplorer, e, activate)}
            >
                <div className="icon-wrapper">
                    <Folder variant="32x32_4" />
                </div>
                <div className="shortcut-label">Stuff</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'paint'}
                onClick={(e, activate) => handleIconClick('paint', openPaint, e, activate)}
            >
                <div className="icon-wrapper">
                    <Mspaint variant="32x32_4" />
                </div>
                <div className="shortcut-label">Paint</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'idlequest'}
                onClick={(e, activate) => handleIconClick('idlequest', () => window.open('https://idlequest.net', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/idlequesticon.png`}
                        alt="IdleQuest"
                    />
                </div>
                <div className="shortcut-label">IdleQuest</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'capturequest'}
                onClick={(e, activate) => handleIconClick('capturequest', () => window.open('https://capturequest.net', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/capturequest.png`}
                        alt="CaptureQuest"
                    />
                </div>
                <div className="shortcut-label">CaptureQuest</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'luckybreak'}
                onClick={(e, activate) => handleIconClick('luckybreak', () => window.open('https://luckybreak.app', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/luckybreak.png`}
                        alt="Lucky Break"
                    />
                </div>
                <div className="shortcut-label">Lucky Break</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'newyokosuka'}
                onClick={(e, activate) => handleIconClick('newyokosuka', () => window.open('https://www.newyokosuka.com/', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/images/ny.gif`}
                        alt="New Yokosuka"
                    />
                </div>
                <div className="shortcut-label">New Yokosuka</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'media'}
                onClick={(e, activate) => handleIconClick('media', startWebamp, e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/images/winamp.png`}
                        alt="Winamp"
                    />
                </div>
                <div className="shortcut-label">Winamp</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'photo'}
                onClick={(e, activate) => handleIconClick('photo', openPhoto, e, activate)}
            >
                <div className="icon-wrapper">
                    <Wangimg130 variant="32x32_4" />
                </div>
                <div className="shortcut-label">hi-res-travel-photo.jpg</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'about'}
                onClick={(e, activate) => handleIconClick('about', () => openNotepad({ id: 'about', name: 'About.txt' }), e, activate)}
            >
                <div className="icon-wrapper">
                    <Notepad2 variant="32x32_4" />
                </div>
                <div className="shortcut-label">About.txt</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'projects'}
                onClick={(e, activate) => handleIconClick('projects', () => openNotepad({ id: 'projects', name: 'Projects.txt' }), e, activate)}
            >
                <div className="icon-wrapper">
                    <Notepad2 variant="32x32_4" />
                </div>
                <div className="shortcut-label">Projects.txt</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'vanguard'}
                onClick={(e, activate) => handleIconClick('vanguard', () => window.open('https://www.eternalsagas.com/', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/vanguard.png`}
                        alt="Vanguard: Eternal Sagas"
                    />
                </div>
                <div className="shortcut-label">Vanguard: Eternal Sagas</div>
            </StyledShorcut>

            <StyledShorcut
                isSelected={activeSelection === 'vayeate'}
                onClick={(e, activate) => handleIconClick('vayeate', () => window.open('https://www.vayeate.com/', '_blank'), e, activate)}
            >
                <div className="icon-wrapper">
                    <StyledIcon
                        src={`${process.env.PUBLIC_URL}/icons/vayeate.png`}
                        alt="Vayeate"
                    />
                </div>
                <div className="shortcut-label">Vayeate Game Studio</div>
            </StyledShorcut>
        </div>
    )
}

export default React.memo(Shortcuts);
